// Sections
import { setupHeader } from './sections/header.js'
import { setupCollection } from './sections/plp-grid.js'
import { setupMainProduct } from './sections/main-product.js'
import { setupBlog } from './sections/main-blog.js'
import { setupArticle } from './sections/article.js'
import { setupArchiveDetails } from './sections/archive-details.js'
import { setupProductRecommendations } from './sections/product-recommendations.js'
import { setupYearsDiagram } from './sections/years-diagram.js'
import { setupStoresList } from './sections/stores-list.js'
import { setupEyewearStoresList } from './sections/eyewear-stores-list.js'
import { setupImageWithTexts } from './sections/image-with-text.js'
import { setupFooter } from './sections/footer.js'
import { setupAccount } from './sections/account.js'
import { setupCart } from './sections/cart.js'
import { setupCustomerServices } from './sections/customer-services.js'
import { setupMainLogin } from  './sections/main-login.js'
import { setupCookiesWrapperTracking } from './utils/Gtm.js'


// Components
// import { setupCookiePop } from './components/CookiePopup.js'
import { setupPaginations } from './components/Pagination.js'
import { setupVideos } from './components/Video.js'
import { setupPopup } from './components/Popup.js'
import { setupCountryPop } from './components/CountryPopup.js'

// Utils
import { scrollToSection } from './utils/helpers.js'
import { GTM_plpViewItems } from './utils/Gtm.js'

function onPageReady() {
  const plpContainer = document.querySelector('#AjaxinateContainer')
  if(plpContainer) {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      method: 'scroll',
      offset: 1000,
      callback: function() {
        window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
        window.setupApiTiles(plpContainer)

        // Track PLP loaded pages
        GTM_plpViewItems(document.querySelectorAll('#product-grid [data-gtm-items-el]:not(.gtm-item_viewed)'));

        setTimeout(() => {
          if (typeof window._swat === 'undefined') {
            console.warn('SWAT is not loaded, skipping wishlist initialization')
            return
          }
          window._swat.initializeActionButtons(`#product-grid`, '.plp-wishlist-btn')
        }, 300)
      }
    })
    setInterval(() => {
      window.setupApiTiles(plpContainer)
    }, 500)
  }

  // Sections
  setupHeader()
  setupCollection()
  setupMainProduct()
  setupBlog()
  setupArticle()
  setupArchiveDetails()
  setupProductRecommendations()
  setupYearsDiagram()
  setupStoresList()
  setupEyewearStoresList()
  setupImageWithTexts()
  setupFooter()
  setupAccount()
  setupCart()
  setupCustomerServices()
  setupMainLogin()

  // Components
  // setupCookiePop()
  setupVideos()
  setupPaginations()
  setupPopup()
  setupCountryPop()

  // Utils
  scrollToSection()
  setupCookiesWrapperTracking()
}

document.addEventListener('DOMContentLoaded', onPageReady)
document.addEventListener('PLPFilteredResultsLoaded', onPageReady)